import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { GetUserFeaturesModel } from '../response/GetUserFeatureForDto.model';
import { AuthUserService } from '../services/AuthUser.service';
import { ServiceBase } from './service-base.model';

const defaultPath = '/';

@Injectable()
export class AuthService {
  jwtHelper: JwtHelperService = new JwtHelperService();

  get loggedIn(): boolean {
    return true;
    // console.log('!this.jwtHelper.isTokenExpired(this.getToken())', !this.jwtHelper.isTokenExpired(this.getToken()));
    return !this.jwtHelper.isTokenExpired(this.getToken());
  }

  private _lastAuthenticatedPath: string = defaultPath;
  set lastAuthenticatedPath(value: string) {
    this._lastAuthenticatedPath = value;
  }

  isLoggedIn(): boolean {
    // return true;
    return !this.jwtHelper.isTokenExpired(this.getToken());
  }

  setAreaCode(areaCode: number) {
    localStorage.setItem('areaCode', areaCode.toString());
  }

  getAreaCode() {
    return localStorage.getItem('areaCode') || 1;
  }

  getToken() {
    return localStorage.getItem('Token')?.toString();
  }

  logout() {
    this.clearSession();
    // this.router.navigate(['/login-form']);
  }

  // async logOut() {
  //   this._user = null;
  //   this.clearSession();
  //   this.router.navigate(['/login-form']);
  // }

  clearSession() {
    localStorage.removeItem('Token');
    localStorage.removeItem('Auth');
  }

  // 檢查是否有此功能的權限
  hasFeature(key: string, permission: number): boolean {
    var FeatureSource: GetUserFeaturesModel[];
    FeatureSource = JSON.parse(localStorage.getItem('Auth')!) as GetUserFeaturesModel[];
    // console.log('FeatureSource', FeatureSource);
    if (FeatureSource != undefined && FeatureSource != null) {
      for (var i = 0; i < Object.keys(FeatureSource).length; i++) {
        if (FeatureSource[i].FunctionId == key && (permission & FeatureSource[i].PermissionNum) == permission) {
          return true;
        }
      }
    }
    return false;
    // return true;
  }

  // 傳入功能代碼, 確認此帳號是否有此權限
  hasRight(key: string): boolean {
    // console.log('key', key);
    var permstr: GetUserFeaturesModel[];
    permstr = JSON.parse(localStorage.getItem('Auth')!) as GetUserFeaturesModel[];
    if (permstr != undefined && permstr != null) {
      for (var i = 0; i < Object.keys(permstr).length; i++) {
        if (permstr[i].FunctionId == key) {
          // console.log('match', key);
          return true;
        }
      }
    }
    return false;
    // return true;
  }

  showPanel(panelNum: number) {
    switch (panelNum) {
      case 1:
        if (this.hasRight('LINE') || this.hasRight('CARELIST') || this.hasRight('DATAREMOVE') || this.hasRight('DISCARDLIST')) { return true; }
        break;
      case 2:
        if (this.hasRight('STATISTICS01') || this.hasRight('STATISTICS02') || this.hasRight('STATISTICS03')
          || this.hasRight('STATISTICS04') || this.hasRight('STATISTICS05') || this.hasRight('STATISTICS06')) { return true; }
        break;
      case 3:
        if (this.hasRight('REPORTSSI') || this.hasRight('REPORTCSI') || this.hasRight('REPORTPOINT') || this.hasRight('REPORTTHUMBSUP')) { return true; }
        break;
      case 4:
        if (this.hasRight('USERLIST') || this.hasRight('ROLE') || this.hasRight('PARAMETER') || this.hasRight('DEPARTMENT')
          || this.hasRight('LOGOPERATION')) { return true; }
        break;

    }
    return false;
  }
}

@Injectable()
export class AuthGuardService implements CanActivate {
  constructor(private router: Router, private authService: AuthService) { }

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const isLoggedIn = this.authService.loggedIn;
    const isAuthForm = [
      'login-form',
      'reset-password',
      'create-account',
      'change-password/:recoveryCode'
    ].includes(route.routeConfig?.path || defaultPath);

    //console.log('isAuthForm', isAuthForm);
    //console.log('AUTH-isLoggedIn', isLoggedIn);
    if (isLoggedIn && isAuthForm) {
      this.authService.lastAuthenticatedPath = defaultPath;
      this.router.navigate([defaultPath]);
      return false;
    }
    // debugger;
    // console.log('AUTH-isLoggedIn-2', isLoggedIn);
    if (!isLoggedIn && !isAuthForm) {
      this.router.navigate(['/login-form']);
    }

    //console.log('AUTH-isLoggedIn-3', isLoggedIn);
    if (isLoggedIn) {
      this.authService.lastAuthenticatedPath = route.routeConfig?.path || defaultPath;
    }

    return isLoggedIn || isAuthForm;
  }
}
